import UploaderProvider from "../../../contexts/uploaderContext/uploaderContext.js";
import LightBoxManager from "components/Structure/LightBoxManager/LightBoxManager.js";
import useBackground from "hooks/useBackground.ts";
import { useEffect } from "react";
import { HomeSidePanel } from "./HomeSidePanel.js";
import { HomeContent } from "./HomeContent.js";
import { UploaderApiInitWrapper } from "./UploaderComponent/UploaderApiInitWrapper.js";
import { useContent } from "contexts/contentContext/contentContext.js";
import { useMobileAppHeight } from "hooks/useMobileAppHeight.js";
import { useUser } from "contexts/userContext/userContext.js";

import "./Home.scss";

export const Home = () => {
  const {
    fetchDefaultBackgroundImage,
    fetchAdsBackground,
    getLanguage,
    setAdsBackground,
  } = useContent();
  const { getUserData, isTokenExist } = useUser();
  const { getCampaignIdsForExcluding } = useBackground();

  useEffect(() => {
    if (!isTokenExist) {
      fetchDefaultBackgroundImage({
        location: "NEWHOMEPAGE",
        campaignIds: getCampaignIdsForExcluding(),
      });
    } else {
      if (getUserData().UserId) {
        if (
          !getUserData().SetCoverOnNewHomePage ||
          !getUserData().UserBackgroundCoverImage
        ) {
          fetchDefaultBackgroundImage({
            location: "NEWHOMEPAGE",
            campaignIds: getCampaignIdsForExcluding(),
          });
        } else if (getUserData().UserBackgroundCoverImage) {
          setAdsBackground({});
        }
      }
    }
  }, [getUserData().UserId]);

  useEffect(() => {
    if (window.location.href.includes("/home/uploading")) {
      window.location.pathname = `/${getLanguage()}/home`;
    } else if (window.location.href.includes("/home/preview-ad-")) {
      fetchAdsBackground();
    }
  }, []);

  useMobileAppHeight();

  return (
    <div className="home-container">
      <HomeSidePanel />
      <div className="home-main-container">
        <UploaderProvider>
          <UploaderApiInitWrapper />
        </UploaderProvider>
      </div>
      <HomeContent />
      <LightBoxManager ignoreUrl={true} />
      <div className="promo-popup-container" />
    </div>
  );
};
